export default __webpack_public_path__ + "static/media/ve.566e1086.svg";